module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_8019.2031fc01.png";